import Client from '@inter-ikea-digital/iig-rpd-dpd-packages-storage-api-client'
export default Client('/api/storage')
